import { createFileRoute, redirect } from '@tanstack/react-router';
import { AutomationsDemo } from '~/features/automations';
import { DocumentTitle } from '~/components/DocumentTitle';
import { NestedRouteErrorBoundary } from '~/components/errors/NestedRouteErrorBoundary';

export const Route = createFileRoute('/_auth/_home/_layout/home/automations')({
  component: AutomationsRoute,
  errorComponent: NestedRouteErrorBoundary,
  loader: async () => {
    // Check if automations are enabled
    const enableAutomations = localStorage.getItem('enableAutomations') === 'true';
    if (!enableAutomations) {
      throw redirect({
        to: '/home/integrations',
      });
    }
    return {};
  },
});

function AutomationsRoute() {
  return (
    <>
      <DocumentTitle title="Browser AI | Versori" />
      <AutomationsDemo />
    </>
  );
}
